<template>
  <div class="payroll-attendance-main-content">
    <div class="payroll-attendance-panel">
      <div class="payroll-attendance-panel-header">
        <span class="icon">📅</span>
        <h2>Attendance Details</h2>
      </div>
      <div class="payroll-attendance-panel-body">
        <div class="payroll-attendance-form-group">
          <div class="input-with-reset">
            <label>Working Days</label>
            <ResetIconButton @reset="() => resetIfEmpty('requiredWorkingDaysInput')" />
          </div>
          <input type="number" v-model="requiredWorkingDaysInput" :disabled="isDisabled"
            @input="updateRequiredWorkingDays" min="0" placeholder="0" @wheel="$event.target.blur()"
            :class="{ 'updated-field': hasChanged('requiredWorkingDaysInput') }" :max="this.getDaysInMonth()" />
        </div>
        <div class="payroll-attendance-form-group">
          <div style="display: flex; justify-content: space-between;">
            <div class="input-with-reset">
              <label>Days Worked</label>
              <ResetIconButton @reset="() => resetIfEmpty('daysWorkedInput')" />

              <span class="required-hours-tooltip-wrapper" @mouseover="showDaysWorkedInfo" @mouseleave="hideDaysWorkedInfo">
                <i class="fa fa-info-circle" style="color: yellowgreen;"></i>
                <div v-if="isDaysWorkedVisible" class="required-hours-tooltip-box">
                  <p>Normal Days Worked: {{ formattedNormalDaysWorked() }}</p>
                  <template v-if="employee.eligibleHolidayDetails && employee.eligibleHolidayDetails.length">
                    <b>Public Holidays Included: ({{ employee.eligibleHolidayDetails.length }})</b>
                    <ul>
                      <li v-for="(item, index) in employee.eligibleHolidayDetails" :key="'hol-' + index">{{ item }}</li>
                    </ul>
                  </template>
                  <template v-if="HalfDaysDetails().length">
                    <b>Additional Half Days: ({{ HalfDaysDetails().length || 0}}) * 0.5 = {{ (HalfDaysDetails().length || 0) * 0.5 }}</b>
                    <ul>
                      <li v-for="(date, index) in HalfDaysDetails()" :key="index">{{ date }}</li>
                    </ul>
                  </template>
                  <p v-if="HalfDaysCount().totalHalfDayHours"><b>Total Half Days Hours:</b> <br> {{
                    HalfDaysCount().totalHalfDayHours }}</p>
                </div>
              </span>
            </div>
            <span style="font-size: smaller; float: right;">
              Half Days: {{ HalfDaysCount().halfDaysCount || 0 }}
            </span>
          </div>
          <input type="number" v-model="daysWorkedInput" :disabled="isDisabled" @input="updateWorkingDays" min="0"
            placeholder="0" step="0.5" @wheel="$event.target.blur()"
            :class="{ 'updated-field': hasChanged('daysWorkedInput') }" :max="this.getRequiredWorkingDays()" />
        </div>
        <div class="payroll-attendance-form-group">
          <div class="input-with-reset">
            <label>Absents</label>
            <!-- <ResetIconButton @reset="() => resetIfEmpty('absentsInput')" /> -->
            <span class="required-hours-tooltip-wrapper" @mouseover="showAbsentInfo" @mouseleave="hideAbsentInfo">
              <i class="fa fa-info-circle" style="color: yellowgreen;"></i>
              <div v-if="isAbsentInfoVisible" class="required-hours-tooltip-box"
                style="margin-left: -70px; width: 260px;">
                <template v-if="formattedAbsentsDaysDetails().length">
                  <b>Absent Days: ({{ absentDaysCount() }})</b>
                  <ul>
                    <li v-for="(item, index) in formattedAbsentsDaysDetails()" :key="'low-' + index">{{ item }}</li>
                  </ul>
                </template>
                <template v-if="formattedAbsentsDetails().length">
                  <b>Low Worked Hours Count: ({{ formattedAbsentsDetails().length }})</b>
                  <ul>
                    <li v-for="(item, index) in formattedAbsentsDetails()" :key="'low-' + index">{{ item }}</li>
                  </ul>
                </template>
                <template v-if="formattedAbsentsDetails(true).length">
                  <b v-if="formattedAbsentsDetails(true).length !== null">
                    Remaining Half Day Absence Count * 0.5: ({{ formattedAbsentsDetails(true).length || 0 }}) * 0.5 = {{
                      (formattedAbsentsDetails(true).length || 0) * 0.5 }}
                  </b>
                  <ul>
                    <li v-for="(item, index) in formattedAbsentsDetails(true)" :key="'half-' + index">{{ item }}</li>
                  </ul>
                </template>
              </div>
            </span>
          </div>
          <input type="number" v-model="absentsInput" :disabled="true" @input="updateAbsents" step="0.5" min="0"
            placeholder="0" @wheel="$event.target.blur()"
            :class="[{ 'updated-field': hasChanged('absentsInput') },'payroll-disabled-field']"
            :max="this.getRequiredWorkingDays()" :min="0" />
        </div>
        <div class="payroll-attendance-form-group">
          <div style="display: flex; justify-content: space-between;">
            <div class="input-with-reset">
              <label>Leaves Taken</label>
              <!-- <ResetIconButton @reset="() => resetIfEmpty('leavesTakenInput')" /> -->
              <span class="required-hours-tooltip-wrapper" @mouseover="showLeavesInfo" @mouseleave="hideLeavesInfo">
                <i class="fa fa-info-circle" style="color: yellowgreen;"></i>
                <div v-if="isleaveInfoVisible" class="required-hours-tooltip-box" style="margin-left: -70px; width: 200px; ">
                  <div v-if="!this.getLeavesAllowed()">Disabled due to 0 Leave Balance.<br></div>
                  <template v-if="leavesTakenInput > 0">
                      <b>Leave Balance Info</b>
                      <ul style="padding-left: 16px;">
                        <li>Leaves Allowed: {{ getLeaveTooltipInfo.leavesAllowed }}</li>
                        <li>Leaves taken: {{ getLeaveTooltipInfo.leavesTaken }}</li>
                        <li>Remaining: {{ getLeaveTooltipInfo.remaining }}</li>
                      </ul>
                  </template>
                  <template v-if="formattedLeavesDetails().length">
                    <b>Monthly Leaves Details: ({{ formattedLeavesDetails().length || 0 }})</b>
                    <ul>
                      <li v-for="(item, index) in formattedLeavesDetails()" :key="'leave-' + index">{{ item }}</li>
                    </ul>
                  </template>

                  <template v-else>
                    <p>No leaves taken for this month.</p>
                  </template>
                </div>
              </span>
            </div>

            <span style="font-size: smaller; float: right;">(Leaves Balance: {{ getLeaveTooltipInfo.remaining  }})</span>
          </div>
          <input type="number" v-model="leavesTakenInput" :disabled="true" @input="updateLeavesTaken"
            :max="this.getLeavesAllowed()" min="0" step="0.5" placeholder="0" class="payroll-disabled-field"
            @wheel="$event.target.blur()" :class="[
              !this.getLeavesAllowed() ? 'payroll-disabled-field' : '',
              hasChanged('leavesTakenInput') ? 'updated-field' : '']" />
        </div>
        <div class="payroll-attendance-form-group">
          <div style="display: flex; justify-content: space-between;">
            <div class="input-with-reset">
              <label>Late Arrivals </label>
              <ResetIconButton @reset="() => resetIfEmpty('lateArrivalsInput')" />
            </div>
            <span style="font-size: smaller; float: right;">
              Late Deduction Days: {{ lateDeductionDays || 0 }}
            </span>
          </div>
          <input type="number" v-model="lateArrivalsInput" :disabled="isDisabled" @input="updateLateArrivals" min="0"
            placeholder="0" @wheel="$event.target.blur()" :class="{ 'updated-field': hasChanged('lateArrivalsInput') }"
            :max="this.getRequiredWorkingDays()" />
        </div>
        <div class="payroll-attendance-form-group">
          <div class="input-with-reset">
            <label>Late Deductions Count </label>
            <ResetIconButton @reset="() => resetIfEmpty('lateSalaryDeductionInput')" />
          </div>
          <input type="number" v-model="manualLateDeductionInput"
            :disabled="isDisabled || !leaveBalance && !leavesTakenInput" min="0" @input="updateLateSalaryDeductionDays"
            placeholder="0" @wheel="$event.target.blur()" :max="this.getRequiredWorkingDays()" :class="[!leaveBalance && !leavesTakenInput ? 'payroll-disabled-field' : '',
            hasChanged('manualLateDeductionInput') ? 'updated-field' : '']" />
        </div>
        <div class="payroll-attendance-form-group">
          <div style="display: flex; justify-content: space-between; flex-wrap: wrap;">
            <div class="input-with-reset">
              <label>Leave Deduction Count</label>
              <ResetIconButton @reset="() => resetIfEmpty('leaveDeductionInput')" />
            </div>
            <div>
              <span style="font-size: smaller; float: right;">(New Leave Balance: {{ this.getNewLeaveBalance || 0
              }})</span>
            </div>
          </div>
          <input type="number" v-model="leaveDeductionInput"
            :disabled="isDisabled || !Number(this.getLeavesAllowed()) && !Number(leavesTakenInput)"
            @input="handleManualLeaveDeduction" min="0" :max="getMaxLeavesDeduction" placeholder="0"
            @wheel="$event.target.blur()" step="0.5" :class="[!Number(this.getLeavesAllowed()) && !Number(leavesTakenInput) ? 'payroll-disabled-field' : '',
            hasChanged('leaveDeductionInput') ? 'updated-field' : '']" />
        </div>
        <div class="payroll-attendance-form-group">
          <div class="input-with-reset">
            <label>Leave Deduction Note</label>
            <ResetIconButton @reset="() => resetIfEmpty('leaveDeductionNote')" />
          </div>

          <textarea class="payroll-adjustment-textarea" v-model="leaveDeductionNote" :disabled="isDisabled"
            placeholder="Enter note for leave deduction" :class="{ 'updated-field': hasChanged('leaveDeductionNote') }">
          </textarea>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "../../../../assets/config/firebase";
import { lateRules, monthMap, deductionRules } from '../../../../assets/config/constants';
import { formatDaysToDateArray, formatDecimalHours, getTotalDaysInMonth } from '../../../../assets/config/helpers';
import ResetIconButton from "../../../UIComponents/Buttons/ResetIconButton.vue";

export default {
  name: "AttendanceDetails",
  components: {
    ResetIconButton
  },
  props: {
    employee: {
      type: Object,
      required: true,
    },
    initialValues: {
      type: Object,
      required: true,
    },
  },
  data() {
    console.log("employee", this.employee)
    return {
      currentUser: null,
      requiredWorkingDaysInput: "",
      daysWorkedInput: "",
      leavesTakenInput: "",
      absentsInput: "",
      lateArrivalsInput: "",
      leaveBalance: "",
      leaveDeductionInput: "",
      salaryDeductionInput: 0,
      lateDeductionDays: this.employee.lateDeductionDays || "",
      totalLatesCount: 0,
      manualLateDeductionInput: "",
      isLeaveDeductionManuallyUpdated: false,
      isLateDeductionManuallyUpdated: false,
      manualLeaveDeduction: "",
      previousAbsents: 0,
      originalLeavesTaken: 0,
      originalDaysWorked: 0,
      daysWorkedWhenLeavesZero: null,
      previousLeavesTaken: 0,
      isAbsentInfoVisible: false,
      isleaveInfoVisible: false,
      isDaysWorkedVisible: false,
      isWorkingDaysVisible: false,
      leaveDeductionNote: this.employee.leaveDeductionNote || "",
      newLeaveBalance: this.employee.newLeaveBalance || 0,
      absentDays: null,
      resignedAbsentDays: null,
      isAbsentsUpdatedByUser: false,
      holidaysList: [],
      calculatedLeaves: [],
    };
  },
  computed: {
    selectedEmployee() {
      return this.$store.state.payroll.selectedEmployeePayroll || {};
    },
    calculatedLateSalaryDeductionDays() {
      if (this.isLateDeductionManuallyUpdated) {
        return this.manualLateDeductionInput; // Return manual input if it is updated
      }
      return parseInt(this.lateDeductionDays) || "";
    },
    calculatedLeaveDeductionDays() {
      return parseInt(this.leaveDeductionInput) || "";
    },
    calculatedTotalLatesCount() {
      return parseInt(this.totalLatesCount) || "";
    },
    isDisabled() {
      return this.$store.state.auth.user.role !== "admin";
    },
    leavesTaken() {
      return Number((this.selectedEmployee.obtainedLeaves || '0 / 0').split(' / ')[0]) || "";
    },
    leaveDeductionMax() {
      return this.leavesTakenInput || 0;
    },
    getLeaveDeductionNote() {
      if (this.leaveDeductionInput !== this.initialValues.leaveDeductionDays) {
        return true
      }
      return false
    },
    getNewLeaveBalance() {
      const allowed = Number(this.employee.leavesAllowed) || 0;
      const taken = Number(this.currentUser && this.currentUser.leavesTaken) || 0;
      const netAllowed = (allowed - taken).toFixed(2)
      const deduction = Number(this.leaveDeductionInput) || 0;
      const newLeaveBalance = Math.max(Number((netAllowed - deduction).toFixed(2)), 0);
      this.employee.newLeaveBalance = newLeaveBalance;
      this.employee.DBLeavesTaken = this.employee.DBLeavesTaken;
      this.syncToEmployee();
      return newLeaveBalance;
    },

    getMaxLeavesDeduction() {
      const initialLeavesTaken = Number(this.initialValues.leavesTaken) || 0
      const leavesTaken = Number(this.leavesTakenInput) || 0
      const leavesAllowed = Number(this.employee.leavesAllowed) || 0
      if(initialLeavesTaken !== leavesTaken) {
        return leavesAllowed - leavesTaken + initialLeavesTaken
      }
      return leavesAllowed
    },
    getLeaveTooltipInfo() {
      const leavesTaken = Number(this.currentUser && this.currentUser.leavesTaken) || 0;
      const leavesAllowed = this.getLeavesAllowed() || 0;
      const deduction = this.getNewLeaveBalance.deduction || 0;
      const remaining = Math.max(Number((leavesAllowed - leavesTaken).toFixed(2)), 0);
      return {
        leavesAllowed,
        leavesTaken: leavesTaken,
        remaining
      };
    },
    
  },
  methods: {
   
    getLeaveInfoText() {
      const leavesAllowed = this.getLeavesAllowed() || 0;
      const deduction = this.getNewLeaveBalance.deduction || 0;
      const remaining = Math.max(Number((leavesAllowed - deduction).toFixed(2)), 0);
      return `(Leaves Allowed: ${remaining})`;
    },
handleManualLeaveDeduction(e) {
  const manualInput = e && e.target.value;
  this.isLeaveDeductionManuallyUpdated = true;
      if (manualInput === "" || manualInput === "0" || Number(manualInput) === 0) {
    this.leaveDeductionInput = "";
      this.employee.leavesDeductionDays = 0 ;
      this.employee.leaveDeductionCount = "";
      this.employee.manualLeaveDeductionDays = "";
      this.manualLeaveDeduction = "";
  } else {
    this.leaveDeductionInput = "";
    this.leaveDeductionInput = Number(manualInput);
    this.employee.leavesDeductionDays = this.leaveDeductionInput;
    this.employee.leaveDeductionCount = this.leaveDeductionInput;
    this.employee.manualLeaveDeductionDays = this.leaveDeductionInput;
    this.manualLeaveDeduction = this.leaveDeductionInput;
  }
  this.employee.recentUpdatedField = "leavesDeductionDays";
  this.syncToEmployee();
    },
    updateAttendanceData() {
      const {
        obtainedLeaves,
        requiredWorkingDays,
        daysWorked,
        absents,
        lateArrivals,
        leaveDeductionNote,
        lateDeductionDays,
        leavesDeductionDays,
        leaveDeductionCount,
        manualLeaveDeductionDays
      } = this.employee;

      let leaveBalance = 0;
      if (obtainedLeaves && obtainedLeaves.includes(" / ")) {
        [, leaveBalance] = obtainedLeaves.split(" / ").map(Number);
      }

      this.requiredWorkingDaysInput = requiredWorkingDays || "";
      this.daysWorkedInput = daysWorked || "";
      this.leavesTakenInput = obtainedLeaves ? obtainedLeaves.split(" / ")[0] || "0 / 0" : "0 / 0";
      this.absentsInput = absents || "";
      this.lateArrivalsInput = lateArrivals || "";
      this.leaveBalance = leaveBalance || "";
      this.leaveDeductionNote = leaveDeductionNote || "";

      // Set manual deduction inputs from saved employee data
      this.leaveDeductionInput = leavesDeductionDays || leaveDeductionCount || manualLeaveDeductionDays || "";
      this.manualLateDeductionInput = lateDeductionDays || "";
      this.lateDeductionDays = lateDeductionDays || "";

      // Check if saved values differ from calculated defaults to set manual flags
      const defaultLeaveDeduction = this.calculateDefaultLeaveDeduction();
      const defaultLateDeduction = this.calculateDefaultLateDeduction();
      const savedLateDeduction = this.employee.lateDeductionDays;
      const hasSavedLateDeduction = ["draft", "processed"].includes((this.employee.status || "").toLowerCase()) && savedLateDeduction !== undefined && savedLateDeduction !== null;
      if (hasSavedLateDeduction) {
        this.isLateDeductionManuallyUpdated = true;
        this.manualLateDeductionInput = Number(savedLateDeduction);
        this.lateDeductionDays = Number(savedLateDeduction);
        this.employee.lateDeductionDays = Number(savedLateDeduction);
      }
      this.$nextTick(() => {
        this.recalculateAbsents();  
        this.calculateDeductions();
      });
  },
   resetIfEmpty(field) {
      const employeeField = field.replace('Input', '');

      this[field] = this.initialValues[employeeField] || 0;
      if (field === 'leaveDeductionNote') { 
        this.leaveDeductionNote = this.initialValues.leaveDeductionNote || '';
        this.employee.leaveDeductionNote = this.leaveDeductionNote;
        this.syncToEmployee();
      }

      if (field === 'leaveDeductionInput') {
        this.isLeaveDeductionManuallyUpdated = false;
        this.leaveDeductionInput = this.initialValues.leavesDeductionDays || this.calculateDefaultLeaveDeduction();
        this.employee.leavesDeductionDays = this.leaveDeductionInput;
        this.employee.leaveDeductionCount = this.leaveDeductionInput;
        this.employee.manualLeaveDeductionDays = this.leaveDeductionInput;
        this.manualLeaveDeduction = this.leaveDeductionInput;
        this.syncToEmployee();
      }

      if (field === 'lateSalaryDeductionInput') {
        this.isLateDeductionManuallyUpdated = false;
        this.manualLateDeductionInput = this.initialValues.lateDeductionDays || this.calculateDefaultLateDeduction();
        this.lateDeductionDays = this.manualLateDeductionInput;
        this.employee.lateDeductionDays = this.manualLateDeductionInput;
        this.syncToEmployee();
      }

      if (field === 'leavesTakenInput') {
        const initialLeaves = this.initialValues.obtainedLeaves ?
         this.initialValues.obtainedLeaves.split(" / ")[0] :
         0;
        this.leavesTakenInput = initialLeaves;

        if (this.employee.obtainedLeaves) {
          const [, balance] = this.employee.obtainedLeaves.split(" / ");
          this.employee.obtainedLeaves = `${initialLeaves} / ${balance}`;
        }
        this.employee.leavesTaken = Number(initialLeaves);

        this.syncToEmployee();
      }
      if (field === 'daysWorkedInput') {
        this.daysWorkedInput = this.initialValues.daysWorked || 0;
        this.employee.daysWorked = this.daysWorkedInput;
        this.absentsInput = this.initialValues.absents || 0;
        this.employee.absents = this.absentsInput;
        this.isAbsentsUpdatedByUser = false;
        this.$nextTick(() => this.recalculateAbsents());
        this.syncToEmployee();
      }
      if (field === 'requiredWorkingDaysInput') {
        this.requiredWorkingDaysInput = this.initialValues.requiredWorkingDays || 0;
        this.employee.requiredWorkingDays = this.requiredWorkingDaysInput;

        const salary = Number(this.employee.salary || this.employee.basicSalary || 0);
        const extraAllowance = Number(this.employee.extraAllowance || 0);
        const grossSalary = salary + extraAllowance;
        this.employee.perDaySalary = this.requiredWorkingDaysInput
          ? parseFloat(grossSalary) / Number(this.requiredWorkingDaysInput)
          : 0;
        this.isAbsentsUpdatedByUser = false;
        this.$nextTick(() => this.recalculateAbsents());
        this.syncToEmployee();
      }
      if (field === 'lateArrivalsInput' || field === 'lateSalaryDeductionInput') {
        this.calculateDeductions()
        this.lateDeductionDays = this.calculatedLateSalaryDeductionDays;
        this.updateLateSalaryDeductionDays()
      }

      // Update the employee object if needed
      if (this.employee[employeeField] !== this[field]) {
        this.employee[employeeField] = this[field];
        this.syncToEmployee();
      }

    },
    absentDaysCount() {
      return Math.max(0, Number(this.absentsInput) || 0);
    },
    recalculateAbsents() {
      const requiredDays = Number(this.requiredWorkingDaysInput) || 0;
      const daysWorked = Number(this.daysWorkedInput) || 0;
      const leavesTaken = Number(this.leavesTakenInput) || 0;

      // Ensure absents can't be negative
      const newAbsents = Math.max(0, requiredDays - daysWorked - leavesTaken);

      this.absentsInput = newAbsents;
      this.employee.absents = newAbsents;
    },
    calculateDeductions() {
      const lates = Number(this.lateArrivalsInput) || 0;
      const leavesTaken = Number(this.currentUser && this.currentUser.leavesTaken) || 0;
      const leavesAllowed = this.getLeavesAllowed() || 0;
      const leavesBalance = Math.max(Number((leavesAllowed - leavesTaken).toFixed(2)), 0);

      let leaveDeductionDays = 0;
      let lateDeductionDays = 0;
      let totalLatesCount = 0;

      const rule = leavesBalance >= 2
        ? lateRules.find(rule => lates >= rule.minLates) || { leaveDeductionDays: 0, lateDeductionDays: 0, totalLatesCount: 0 }
        : deductionRules.find(rule => lates >= rule.minLates);

      if (rule) {
        if (leavesBalance >= 2) {
          // For leavesBalance >= 2, use lateRules
          leaveDeductionDays = Math.min(rule.leaveDeductionDays, leavesBalance);
          lateDeductionDays = rule.lateDeductionDays;
          totalLatesCount = rule.totalLatesCount;
        } else {
          // For leavesBalance < 2, use deductionRules
          const rangeKey = leavesBalance < 1 ? '<1' : '>=1,<2';
          leaveDeductionDays = Math.min(rule.leaveDeduction[rangeKey], leavesBalance);
          lateDeductionDays = rule.lateDeduction[rangeKey];
          const lateRule = lateRules.find(r => lates >= r.minLates);
          totalLatesCount = lateRule ? lateRule.totalLatesCount : 0;
        }
      }

      leaveDeductionDays = this.roundToHalf(Math.min(leaveDeductionDays, leavesBalance, 2));

      this.leaveBalance = leavesBalance;
        const hasSavedLeaveDeduction =
          this.employee.status === "Draft" &&
        (Number.isFinite(Number(this.employee.leavesDeductionDays)) ||
          Number.isFinite(Number(this.employee.leaveDeductionCount)) ||
          Number.isFinite(Number(this.employee.manualLeaveDeductionDays)));
        if (!this.isLeaveDeductionManuallyUpdated && !hasSavedLeaveDeduction) {
          this.leaveDeductionInput = leaveDeductionDays;
          this.employee.leavesDeductionDays = leaveDeductionDays;
          this.employee.leaveDeductionCount = leaveDeductionDays;
          this.employee.manualLeaveDeductionDays = leaveDeductionDays;
          this.manualLeaveDeduction = leaveDeductionDays;
        } else if (hasSavedLeaveDeduction) {
        this.leaveDeductionInput =
          Number.isFinite(Number(this.employee.leavesDeductionDays)) ? this.employee.leavesDeductionDays :
          Number.isFinite(Number(this.employee.leaveDeductionCount)) ? this.employee.leaveDeductionCount :
          Number.isFinite(Number(this.employee.manualLeaveDeductionDays)) ? this.employee.manualLeaveDeductionDays : "";
          this.employee.leavesDeductionDays = this.leaveDeductionInput;
          this.employee.leaveDeductionCount = this.leaveDeductionInput;
          this.employee.manualLeaveDeductionDays = this.leaveDeductionInput;
          this.manualLeaveDeduction = this.leaveDeductionInput;
        }
      const hasSavedLateDeduction = ["draft", "processed"].includes((this.employee.status || "").toLowerCase()) && Number.isFinite(Number(this.employee.lateDeductionDays));
      if (!this.isLateDeductionManuallyUpdated && !hasSavedLateDeduction) {
        this.lateDeductionDays = lateDeductionDays;
        this.manualLateDeductionInput = lateDeductionDays;
        this.employee.lateDeductionDays = lateDeductionDays;
      } else if (hasSavedLateDeduction) {
        this.lateDeductionDays = this.employee.lateDeductionDays;
        this.manualLateDeductionInput = this.employee.lateDeductionDays;
        this.employee.lateDeductionDays = this.manualLateDeductionInput;
      }
      this.totalLatesCount = totalLatesCount;

      const perDaySalary = Number(this.employee.perDaySalary) || 0;
      this.salaryDeductionInput = (lateDeductionDays * perDaySalary).toFixed(2);

      this.syncToEmployee();
    },
    updateRequiredWorkingDays() {
      const requiredWorkingDays = Number(this.requiredWorkingDaysInput);
      this.employee.requiredWorkingDays = requiredWorkingDays;

      // Recalculate per day salary
      const monthlySalary = Number(this.employee.salary || this.employee.basicSalary || 0) +
        Number(this.employee.extraAllowance) || 0;
      this.employee.perDaySalary = requiredWorkingDays ? monthlySalary / requiredWorkingDays : 0;

      // Recalculate absents when working days change
      this.recalculateAbsents();  // Updated to use shared method
      this.isAbsentsUpdatedByUser = true;  // NEW: Set flag for user-triggered change

      this.syncToEmployee();
    },

    updateLeavesTaken(e) {
      const maxLeaves = Number(this.leaveBalance) || 0;
      const rawValue = Number(e.target.value) || 0;

      // Round to nearest 0.5 and clamp between 0 and maxLeaves
      const newLeavesTaken = Math.min(Math.max(0, this.roundToHalf(rawValue)), maxLeaves);
      this.leavesTakenInput = newLeavesTaken;
      this.employee.leavesTaken = newLeavesTaken;

      // Update obtainedLeaves string
      const obtLeaves = this.employee.obtainedLeaves || "0 / 0";
      if (obtLeaves.includes(" / ")) {
        const [, balance] = obtLeaves.split(" / ");
        this.employee.obtainedLeaves = `${newLeavesTaken} / ${balance}`;
      }

      this.getMaxLeavesDeduction;

      this.employee.recentUpdatedField = "leavesTaken";
      this.recalculateAbsents();  
      this.isAbsentsUpdatedByUser = true;  
      this.calculateDeductions();
      this.syncToEmployee();
    },

    updateAbsents(e) {
      const rawValue = Number(e.target.value || e) || 0;
      const newAbsents = this.roundToHalf(rawValue);

      // Apply updates
      this.absentsInput = newAbsents;
      this.employee.absents = newAbsents;


      this.previousAbsents = newAbsents;

      // Get current values
      const requiredDays = Number(this.requiredWorkingDaysInput) || 0;
      const leavesTaken = Number(this.leavesTakenInput) || 0;

      // Calculate new absents (can't be negative)
      const newDaysWorked = Math.max(0, requiredDays - newAbsents - leavesTaken);
      this.employee.daysWorked = newDaysWorked || 0;
      this.daysWorkedInput = newDaysWorked || 0;

      this.syncToEmployee();
    },

    updateLateArrivals(e) {
      const hasSavedLateDeduction = ["draft", "processed"].includes((this.employee.status || "").toLowerCase()) && Number.isFinite(Number(this.employee.lateDeductionDays));
      if (!hasSavedLateDeduction) {
        this.isLateDeductionManuallyUpdated = false
      }
      this.employee.lateArrivals = Number(this.lateArrivalsInput) || e.target.value;
      this.employee.recentUpdatedField = "lateArrivals";
      this.calculateDeductions();
      this.syncToEmployee();
    },
    updateLeaveDeduction(e) {
      this.isLeaveDeductionManuallyUpdated = true;
      const obtLeaves = this.employee.obtainedLeaves || "0 / 0";
      let updatedLeaves = obtLeaves && obtLeaves.split(" / ");
      updatedLeaves[0] = e.target.value || 0;
      this.employee.obtainedLeaves = updatedLeaves.join(" / ");

      this.employee.leavesDeductionDays = e.target.value || Number(this.leaveDeductionInput)
      this.employee.recentUpdatedField = "leavesDeductionDays";
      this.syncToEmployee();
      this.isLeaveDeductionManuallyUpdated = false
    },
    updateLateSalaryDeductionDays(e) {
      const manualInput = e && e.target.value;

      if (e && manualInput) {
        this.isLateDeductionManuallyUpdated = true;
        this.manualLateDeductionInput = manualInput;
        this.lateDeductionDays = Number(manualInput);
        this.employee.lateDeductionDays = this.lateDeductionDays;
      } else {
        this.isLateDeductionManuallyUpdated = false;
        this.lateDeductionDays = this.calculatedLateSalaryDeductionDays;
      }
      this.syncToEmployee()
    },
    updateWorkingDays() {
      const daysWorked = Number(this.daysWorkedInput) || 0;
      this.employee.daysWorked = daysWorked;

      this.recalculateAbsents();  // Updated to use shared method
      this.isAbsentsUpdatedByUser = true;  // NEW: Set flag for user-triggered change

      this.syncToEmployee();
    },
    syncToEmployee() {
      const obtLeaves = this.employee.obtainedLeaves
      const updated = Object.assign({}, this.employee, {
        requiredWorkingDays: Number(this.requiredWorkingDaysInput),
        daysWorked: Number(this.daysWorkedInput),
        obtainedLeaves: obtLeaves && obtLeaves || `${this.leavesTakenInput} / ${this.leaveBalance}`,
        leavesTaken: obtLeaves && obtLeaves.split(" / ")[0] || this.leavesTakenInput || 0,
        absents: Number(this.absentsInput),
        lateArrivals: Number(this.lateArrivalsInput),
        leaveDeductionDays: Number(this.leaveDeductionInput),
        // lateDeduction: `${Number(this.lateDeductionInput)} - ${this.lateArrivalsInput}`,
        lateDeductionDays: Number(this.lateDeductionDays),
        totalLatesCount: Number(this.totalLatesCount),
        manualLeaveDeductionDays: Number(this.manualLeaveDeduction),
        leaveDeductionNote: this.leaveDeductionNote || "",
        absentDays: this.absentDays || this.employee.absentDays || {}
      });
      this.$emit("update-attendance", updated); // emit updated employee data
    },
    roundToHalf(value) {
      return Math.round(value * 2) / 2;
    },
    calculatedAbsents() {
      var daysWorked = Number(this.selectedEmployee.daysWorked) || 0;
      var leavesTaken = this.leavesTaken;
      var requiredDays = this.requiredWorkingDays;

      var calculated = requiredDays - daysWorked - leavesTaken;
      return Math.max(0, calculated);
    },
    calculateDefaultLeaveDeduction() {
      const lates = parseInt(this.lateArrivalsInput) || 0;
      const leavesTaken = Number(this.currentUser && this.currentUser.leavesTaken) || 0;
      const leavesAllowed = this.getLeavesAllowed() || 0;
      const leavesBalance = Math.max(Number((leavesAllowed - leavesTaken).toFixed(2)), 0);

      const rule = leavesBalance >= 2
        ? lateRules.find(rule => lates >= rule.minLates) || { leaveDeductionDays: 0 }
        : deductionRules.find(rule => lates >= rule.minLates);

      if (rule) {
        if (leavesBalance >= 2) {
          return this.roundToHalf(Math.min(rule.leaveDeductionDays, leavesBalance, 2));
        } else {
          const rangeKey = leavesBalance < 1 ? '<1' : '>=1,<2';
          return this.roundToHalf(Math.min(rule.leaveDeduction[rangeKey], leavesBalance));
        }
      }
      return 0;
    },
    calculateDefaultLateDeduction() {
      const lates = parseInt(this.lateArrivalsInput) || 0;
      const leavesTaken = Number(this.currentUser && this.currentUser.leavesTaken) || 0;
      const leavesAllowed = this.getLeavesAllowed() || 0;
      const leavesBalance = Math.max(Number((leavesAllowed - leavesTaken).toFixed(2)), 0);

      const rule = leavesBalance >= 2
        ? lateRules.find(rule => lates >= rule.minLates) || { lateDeductionDays: 0 }
        : deductionRules.find(rule => lates >= rule.minLates);

      if (rule) {
        if (leavesBalance >= 2) {
          return rule.lateDeductionDays;
        } else {
          const rangeKey = leavesBalance < 1 ? '<1' : '>=1,<2';
          return rule.lateDeduction[rangeKey];
        }
      }
      return 0;
    },
    showAbsentInfo() {
      this.isAbsentInfoVisible = true;
    },
    hideAbsentInfo() {
      this.isAbsentInfoVisible = false;
    },
    showLeavesInfo() {
      this.isleaveInfoVisible = true;
    },
    hideLeavesInfo() {
      this.isleaveInfoVisible = false;
    },
    showDaysWorkedInfo() {
      this.isDaysWorkedVisible = true;
    },
    hideDaysWorkedInfo() {
      this.isDaysWorkedVisible = false;
    },
    showWorkingDaysInfo() {
      this.isWorkingDaysVisible = true;
    },
    hideWorkingDaysInfo() {
      this.isWorkingDaysVisible = false;
    },
    formattedAbsentsDetails(halfDayCount = false) {
      const employee = this.employee || {};
      const absents = halfDayCount ? employee.remainingHalfDays : employee.lowHoursDays || {};
      const formattedDetails = [];

      const monthNum = String(monthMap[employee.month]).padStart(2, '0') || '00'; // Convert 'April' → '04'

      for (const date in absents) {
        if (absents.hasOwnProperty(date)) {
          const decimalHours = absents[date];
          const hours = Math.floor(decimalHours);
          const minutes = Math.round((decimalHours - hours) * 60);
          formattedDetails.push(`${date}-${monthNum}-${employee.year}: ${hours} hrs & ${minutes} mins`);
        }
      }

      if (halfDayCount) {
        this.employee.remainingHalfDays = absents;
      } else {
        this.employee.lowHoursDays = absents;
      }
      this.syncToEmployee();
      return formattedDetails;
    },
    formattedAbsentsDaysDetails() {
      const employee = this.employee || {};
      const isResigned = employee.employeeStatus && employee.employeeStatus.toLowerCase() === 'resigned';
      const absents = (isResigned ? this.resignedAbsentDays : employee.absentDays) || {};

      const monthNum = String(monthMap[employee.month] || 0).padStart(2, '0');
      const year = Number(employee.year);
      if (!monthNum || !year) return [];

      // The count comes from recalculateAbsents(): requiredDays - daysWorked -
      // leavesTaken. Derive the dates from those same inputs so the list and the
      // count always agree, instead of dumping whatever sparse keys the store
      // happened to write into `absentDays`.
      const dayOf = (value) => Number(String(value).split(':')[0].trim().split('-')[0]);

      // Anything the employee recorded time for was attended, not absent.
      const attendedDays = new Set([
        ...Object.keys(employee.normalHoursDays || {}),
        ...Object.keys(employee.lowHoursDays || {}),
        ...Object.keys(employee.halfDays || {}),
        ...Object.keys(employee.remainingHalfDays || {}),
      ].map(Number).filter(Boolean));

      // Public holidays are credited as worked days, so they are never absent.
      (employee.eligibleHolidayDetails || []).forEach((item) => {
        const day = dayOf(item);
        if (day) attendedDays.add(day);
      });
      (this.holidaysList || []).forEach((item) => {
        const day = dayOf(item);
        if (day) attendedDays.add(day);
      });

      // Approved leave days are not absences either.
      (this.calculatedLeaves || []).forEach((dateStr) => {
        const day = dayOf(dateStr);
        if (day) attendedDays.add(day);
      });

      const workingDays = (employee.workingDays || ["monday", "tuesday", "wednesday", "thursday", "friday"])
        .map((day) => day.toLowerCase());
      const daysInMonth = getTotalDaysInMonth(employee.month, employee.year) || 0;
      const lastWorkingDate = isResigned && employee.lastWorkingDate
        ? new Date(employee.lastWorkingDate)
        : null;

      const formattedDetails = [];
      for (let day = 1; day <= daysInMonth; day++) {
        const dateObj = new Date(year, monthNum - 1, day);
        const dayName = dateObj.toLocaleDateString('en-US', { weekday: 'long' }).toLowerCase();
        if (!workingDays.includes(dayName)) continue;
        if (lastWorkingDate && dateObj > lastWorkingDate) continue;
        if (attendedDays.has(day)) continue;

        formattedDetails.push(`${String(day).padStart(2, '0')}-${monthNum}-${year}: Off`);
      }

      this.absentDays = absents;
      this.employee.absentDays = absents;
      this.syncToEmployee();
      return formattedDetails;
    },
    getMissingWorkingDays(employee) {
      const monthInput = employee.month;
      const year = employee.year || new Date().getFullYear();

      const month = typeof monthInput === "string"
        ? new Date(`${monthInput} 1, ${year}`).getMonth() + 1
        : monthInput;
      const workedDays = Object.keys(employee.normalHoursDays).map(Number);
      const holidayDays = (employee.eligibleHolidayDetails || []).map(item => {
        const [date] = item.split(":");
        return Number(date.split("-")[0]);
      });

      // Use the employee's actual schedule rather than assuming Sat/Sun, so a
      // Mon-Sat employee is not reported absent on a day they are required to work.
      const workingDays = (employee.workingDays || ["monday", "tuesday", "wednesday", "thursday", "friday"])
        .map((d) => d.toLowerCase());

      const daysInMonth = new Date(year, month, 0).getDate();
      const missingDays = {};

      for (let day = 1; day <= daysInMonth; day++) {
        const date = new Date(year, month - 1, day);
        const weekDayName = date.toLocaleDateString('en-US', { weekday: 'long' }).toLowerCase();

        const isNonWorkingDay = !workingDays.includes(weekDayName);
        const isWorked = workedDays.includes(day);
        const isHoliday = holidayDays.includes(day);

        if (!isNonWorkingDay && !isWorked && !isHoliday) {
          missingDays[day] = "Off";
        }
      }

      return missingDays;
    },
    async formatPublicHolidays() {
      const holidays = await firebase.getAllHolidays();

      const shift = (this.employee.shift || "Morning").toLowerCase();
      const year = Number(this.employee.year);
      const monthName = (this.employee.month || "").toLowerCase();

      const isResigned = (this.employee.employeeStatus || "").toLowerCase() === 'resigned';

      const lastWorkingDate = isResigned && this.employee.lastWorkingDate
        ? new Date(this.employee.lastWorkingDate)
        : null;

      let workingDays = [];
      if (
        this.employee &&
        Array.isArray(this.employee.workingDays) &&
        this.employee.workingDays.length
      ) {
        workingDays = this.employee.workingDays.map(d => d.toLowerCase());
      } else {
        workingDays = ["monday", "tuesday", "wednesday", "thursday", "friday"];
      }

      const holidayMap = {};

      holidays.forEach(h => {
        const baseDate = new Date(h.dates);
        const isRecurring = !!h.isRecurring;
        const count = h.numberOfDays || 1;

        const hShift = (h.shift || "general").toLowerCase();

        if (
          !(shift === "general" ||
            hShift === "general" ||
            hShift === shift)
        ) {
          return;
        }

        const startDate = new Date(
          isRecurring ? year : baseDate.getFullYear(),
          baseDate.getMonth(),
          baseDate.getDate()
        );

        for (let i = 0; i < count; i++) {
          const d = new Date(startDate);
          d.setDate(startDate.getDate() + i);

          if (lastWorkingDate && d > lastWorkingDate) continue;

          const dayName = d
            .toLocaleDateString("en-US", { weekday: "long" })
            .toLowerCase();

          if (!workingDays.includes(dayName)) continue;

          const dMonthName = d
            .toLocaleString("default", { month: "long" })
            .toLowerCase();

          if (monthName && dMonthName !== monthName) continue;

          const dd = ("0" + d.getDate()).slice(-2);
          const mm = ("0" + (d.getMonth() + 1)).slice(-2);
          const yyyy = d.getFullYear();

          const dateKey = `${dd}-${mm}-${yyyy}`;
          if (!holidayMap[dateKey]) {
            holidayMap[dateKey] = {
              names: [],
              dateObj: d
            };
          }
          holidayMap[dateKey].names.push(h.name);
        }
      });

      const formattedList = Object.keys(holidayMap).map(date => ({
        text: `${date}: ${holidayMap[date].names.join(", ")}`,
        dateObj: holidayMap[date].dateObj
      }));
      formattedList.sort((a, b) => a.dateObj - b.dateObj);

      return formattedList.map(i => i.text);
    },
    formattedNormalDaysWorked() {
      const employee = this.employee || {};
      const normalDays = employee.normalDaysWorked || 0;
      this.employee.normalDaysWorked = normalDays;
      this.syncToEmployee();
      return normalDays;
    },
    formattedLeavesDetails() {
      const employee = this.employee || {};
      const leavesTaken = this.calculatedLeaves || [];

      if (!leavesTaken.length) {
        return [];
      }

      const formatted = [];
      
      const holidaySet = new Set(
        (this.holidaysList || []).map(h => h.split(':')[0].trim())
      );
      const workingDays = (employee.workingDays || ["monday", "tuesday", "wednesday", "thursday", "friday"]).map(day => day.toLowerCase());

      // `calculatedLeaves` is already a flat array of individual leave date
      // strings (getEmployeeApprovedLeaves expands each leave's start→end range
      // into individual dates). So we format each date on its own and must NOT
      // treat consecutive entries as a [start, end] range — doing so incorrectly
      // merged separate single-day leaves (e.g. 15th & 19th) into a 5-day range.
      for (let i = 0; i < leavesTaken.length; i++) {
        const dateStr = leavesTaken[i];
        if (!dateStr) continue;

        const [d, m, y] = dateStr.split('-').map(Number);
        const dateObj = new Date(y, m - 1, d);
        const dayName = dateObj.toLocaleDateString('en-US', { weekday: 'long' }).toLowerCase();
        if (workingDays.includes(dayName) && !holidaySet.has(dateStr)) {
          formatted.push(`Leave Taken: ${dateStr}`);
        }
      }

      return formatted;
    },
    HalfDaysDetails() {
      const employee = this.employee || {};
      const { halfDays, month, year } = employee || {};
      if (!halfDays) return [];
      this.employee.halfDays = halfDays;
      this.syncToEmployee();
      const totalHours = formatDaysToDateArray(halfDays, year, month);
      return totalHours.map((date) => {
        const [day, month, year] = date.split("-");
        return `${day}-${month}-${year}`;
      });
    },
    HalfDaysCount() {
      const employee = this.employee || {};
      const { totalHalfDayHours, halfDays } = employee || {}
      if (!halfDays) return 0
      const halfHourLen = Object.keys(halfDays).length || 0;
      this.employee.totalHalfDayHours = totalHalfDayHours;
      this.syncToEmployee();
      const data = {
        halfDaysCount: halfHourLen,
        totalHalfDayHours: Number(totalHalfDayHours) > 0 ? formatDecimalHours(totalHalfDayHours) : 0,
      }
      return data
    },
    hasChanged(field) {
      const employeeField = field.replace('Input', '');
      if (field === 'absentsInput') {
        return Number(this[field]) !== Number(this.initialValues[employeeField] || 0) && this.isAbsentsUpdatedByUser;
      }
      if (field === 'manualLateDeductionInput') {
        return this.isLateDeductionManuallyUpdated &&
          this[field] !== (this.initialValues.lateDeductionDays || 0);
      }
      if (field === 'leaveDeductionInput') {
        return this.isLeaveDeductionManuallyUpdated &&
          this[field] !== (this.initialValues.leavesDeductionDays || 0);
      }
      if (field === 'leaveDeductionNote') {
        return this.leaveDeductionNote !== (this.initialValues.leaveDeductionNote || '');
      }
      return Number(this[field]) !== Number(this.initialValues[employeeField] || 0);
    },

    getDaysInMonth() {
      return getTotalDaysInMonth(this.employee.month, this.employee.year);
    },
    getRequiredWorkingDays() {
      return Number(this.requiredWorkingDaysInput) || 0;
    },
    getLeavesAllowed() {
      return Number(this.employee.leavesAllowed) || 0;
    }
  },
  watch: {
    employee: {
      handler(newVal) {
        if (newVal.leavesDeductionDays !== undefined &&
            newVal.leavesDeductionDays !== null &&
            !this.isLeaveDeductionManuallyUpdated) {
          this.leaveDeductionInput = newVal.leavesDeductionDays;
        }
        if (newVal.lateDeductionDays !== undefined &&
            newVal.lateDeductionDays !== null &&
            !this.isLateDeductionManuallyUpdated) {
          this.manualLateDeductionInput = newVal.lateDeductionDays;
          this.lateDeductionDays = newVal.lateDeductionDays;
        }
        this.updateAttendanceData();
      },
      immediate: true,
      deep: true
    },
    leaveDeductionNote(newVal) {
      this.employee.leaveDeductionNote = newVal;
      this.syncToEmployee();
    },
  },
  async mounted() {
    this.currentUser = await firebase.getSingleUser(this.employee.employeeId);
    this.updateAttendanceData();

    // Load leaves and holidays independently: a failure in one must not wipe
    // out the other, since both feed the same "Monthly Leaves Details" tooltip.
    const { employeeId, month, year } = this.employee || {};

    this.calculatedLeaves = await firebase
      .getEmployeeApprovedLeaves(employeeId, month, year)
      .catch((err) => {
        console.error("Error loading approved leaves:", err);
        return [];
      });

    this.holidaysList = await this.formatPublicHolidays().catch((err) => {
      console.error("Error loading holidays:", err);
      return [];
    });

    this.resignedAbsentDays = this.getMissingWorkingDays(this.employee);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/PayrollManagement/PayrollDetails/AttendanceDetails/index.vue